// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.frontier.wallet",
    name: "Frontier",
    homepage: "https://www.frontier.xyz",
    image_id: "a78c4d48-32c1-4a9d-52f2-ec7ee08ce200",
    app: {
        browser: "https://www.frontier.xyz/download",
        ios: "https://apps.apple.com/us/app/frontier-defi-wallet/id1482380988",
        android: "https://play.google.com/store/apps/details?id=com.frontierwallet&hl=en_IN&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
        firefox: null,
        safari: null,
        edge: "https://chrome.google.com/webstore/detail/frontier-wallet/kppfdiipphfccemcignhifpjkapfbihd",
        opera: null,
    },
    rdns: "xyz.frontier.wallet",
    mobile: {
        native: "frontier://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map